let merge = require('lodash/merge')
const mutations = {
  SET_SEL_COMPANY(state, company) {
    state.selCompany = company
  },

  UPDATE_COMPANY(state, company) {
    const mergedData = merge(JSON.parse(JSON.stringify(state.selCompany)), company)
    state.selCompany = mergedData
  }
}
export default mutations
